// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar_container__sKTsE","noImg":"Avatar_noImg__C0v_V"};